export enum NoticeEmails {
  ActivateVip = 'activate-vip',
  RestoreProfile = 'restore-profile',
  ConfirmEmail = 'confirm-email',
  ConfirmProfile = 'confirm-profile',
  AccountRemoval = 'account-removal',
  PasswordRecovery = 'password-recovery',
}
